// Mock data for Jani Ribeiro Lash Designer

export const services = [
  {
    id: 1,
    name: "Volume Clássico",
    description: "Técnica natural que realça o olhar com fios individuais aplicados em cada cílio natural.",
    price: 100.00,
    duration: "2h30 aproximadamente"
  },
  {
    id: 2,
    name: "Volume Brasileiro",
    description: "Técnica que proporciona mais volume e definição, com fios mais densos e efeito marcante.",
    price: 120.00,
    duration: "2h45 aproximadamente"
  },
  {
    id: 3,
    name: "Volume Egípcio",
    description: "Técnica premium com efeito volumoso e glamouroso, ideal para quem busca um olhar impactante.",
    price: 160.00,
    duration: "3h aproximadamente"
  },
  {
    id: 4,
    name: "Manutenção",
    description: "Reposição dos fios que caíram naturalmente. Valores a combinar conforme avaliação (15, 20 ou 30 dias).",
    price: null,
    duration: "A combinar"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mariana Silva",
    text: "Simplesmente apaixonada! Os cílios ficaram super naturais e confortáveis. Já estou agendando a manutenção!",
    rating: 5
  },
  {
    id: 2,
    name: "Fernanda Costa",
    text: "A Jani é uma artista! A durabilidade das extensões é incrível, já faz 3 semanas e continuam perfeitos.",
    rating: 5
  },
  {
    id: 3,
    name: "Camila Rodrigues",
    text: "Melhor lash designer da região! Trabalho impecável, ambiente super aconchegante e atendimento nota 10.",
    rating: 5
  },
  {
    id: 4,
    name: "Patricia Oliveira",
    text: "Fiz o Volume Egípcio e amei! Nunca imaginei que ficaria tão lindo e natural ao mesmo tempo. Super recomendo!",
    rating: 5
  }
];

export const contactInfo = {
  phone: "47997653276",
  whatsapp: "5547997653276",
  email: "janiribeiro.lashdesigner@gmail.com",
  address: {
    street: "R. Conde d'Eu, 611",
    neighborhood: "Bairro Alpino",
    city: "São Bento do Sul",
    state: "SC",
    cep: "89286-691",
    reference: "Acesso junto ao Studio Val"
  }
};

export const businessHours = {
  note: "Horário a combinar",
  description: "Atendimento com horário flexível, agende seu horário via WhatsApp."
};
